/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-24 12:35:31
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-24 16:14:04
 * @FilePath: /unifyxp-v2-store-portal/src/layout/index.ts
 */

/*
现在portal项目编辑页面主体有两种 一种是sales channel的左右拖拽结构，
一种是virtual product那种section为模块编辑结构
 */

/*
sales channel的左右拖拽结构-主页
这种页面整体数据结构都以 redux 作为数据源
主体页面结构 使用 PageWrapper
leftChild放 preview 用 PreviewWrapper包裹
right 放 具体内容配置 用 RightConfigWrapper 包裹
整个页面用 BasicPageHOC 包裹
例子 ： src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/index.tsx
 */

import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import { PreviewWrapper } from 'src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';

/*
sales channel的左右拖拽结构-left preview
整个页面用 PreviewContainer 包裹
例子 ： src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/Preview/index.tsx
 */

import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';

/*
1.sales channel的左右拖拽结构-right部分每块内容

 */

export {
  BasicPageHOC,
  PageWrapper,
  RightConfigWrapper,
  PreviewWrapper,
  PreviewContainer,
};
